import { BulkCreateEmployeesResponseDTO } from '@/core/dto/psychosocial-report';
import { BulkCreateEmployeesResponse } from '@/types/Psychosocial';

export class BulkCreateEmployeeMapper {
	constructor(private readonly data: BulkCreateEmployeesResponseDTO) {}

	toDomain(): BulkCreateEmployeesResponse {
		return {
			status: this.data.status,
			message: this.data.message
		};
	}
}
